import FilterSection from "@SearchResults/features/sidebar/components/FilterSection";
import React from "react";
import {SearchResultsRtkQueryResponseType} from "@SearchResults/api/types/SearchResultsRtkQueryResponse.type";
import MTicketEcoFriendlyFilter
    from "@SearchResults/features/sidebar/features/popularFilters/components/MTicketEcoFriendlyFilter";
import WebDiscountFilter from "@SearchResults/features/sidebar/features/popularFilters/components/WebDiscountFilter";
import InstantConfirmationFilter
    from "@SearchResults/features/sidebar/features/popularFilters/components/InstantConfirmationFilter";
import useDisplayPopularFilters
    from "@SearchResults/features/sidebar/features/popularFilters/hooks/useDisplayPopularFilters";
import DirectFilter from "@SearchResults/features/sidebar/features/popularFilters/components/DirectFilter";
import ParamsType from "@SearchResults/types/params/Params.type";

type PopularFiltersProps = {
    searchData: SearchResultsRtkQueryResponseType
    params: ParamsType
}

function PopularFilters({searchData, params}: PopularFiltersProps) {
    const {
        displayMTicketFilter,
        displayInstantConfirmationFilter,
        displayWebDiscountFilter,
        displayDirectRoutesFilter,
    } = useDisplayPopularFilters(searchData, params)

    if (!displayMTicketFilter && !displayInstantConfirmationFilter && !displayWebDiscountFilter) {
        return null;
    }

    return (
        <FilterSection translationKey="search_results.filter_by.popular_filters.label">
            {displayInstantConfirmationFilter && (
                <InstantConfirmationFilter/>
            )}
            {displayMTicketFilter && (
                <MTicketEcoFriendlyFilter/>
            )}
            {displayWebDiscountFilter && (
                <WebDiscountFilter/>
            )}
            {displayDirectRoutesFilter && (
                <DirectFilter/>
            )}
        </FilterSection>
    );
}

export default PopularFilters;